import React, { memo } from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FeaturesSection() {
  const features = ['Manage WhatsApp leads and active clients in one view', "See today's appointments, follow-ups, and reminders", 'Set and track follow-ups so nothing slips', 'Send WhatsApp reminders for sessions and payments', 'Keep client notes and care plans organised'];
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-27">
      <div className="text-center mb-16" data-id="element-28">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-6" data-id="element-29">
          Welma quietly runs the day-to-day of your practice
        </h2>
        <p className="text-xl text-[#7B9AAA] font-medium" data-id="element-30">
          Think of Welma as your practice's memory.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-31">
        <div className="space-y-6" data-id="element-32">
          {features.map((feature, index) => <div key={index} className="flex items-start" data-id="element-33">
              <CheckCircle2 className="w-6 h-6 text-[#8B9D83] mr-4 flex-shrink-0 mt-0.5" data-id="element-34" />
              <span className="text-lg text-[#2D2D2D]/90" data-id="element-35">{feature}</span>
            </div>)}
        </div>

        <div className="space-y-6" data-id="element-36">
          {/* Placeholder Screenshot 1 */}
          <div className="bg-white p-2 rounded-2xl shadow-sm border border-[#A39B8B]/20 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-37">
            <div className="aspect-[16/10] bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 overflow-hidden relative" data-id="element-38">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100/50" data-id="element-39" />
              <div className="text-center relative z-10 p-6" data-id="element-40">
                <div className="w-12 h-12 bg-[#8B9D83]/20 rounded-full mx-auto mb-3 flex items-center justify-center" data-id="element-41">
                  <span className="text-[#8B9D83] font-bold text-xl" data-id="element-42">W</span>
                </div>
                <p className="text-sm font-medium text-gray-400 uppercase tracking-wider" data-id="element-43">
                  Dashboard View
                </p>
              </div>
              {/* Abstract UI lines */}
              <div className="absolute top-4 left-4 right-4 space-y-2 opacity-30" data-id="element-44">
                <div className="h-2 bg-gray-300 rounded w-1/3" data-id="element-45"></div>
                <div className="h-2 bg-gray-200 rounded w-1/4" data-id="element-46"></div>
              </div>
            </div>
          </div>

          {/* Placeholder Screenshot 2 */}
          <div className="bg-white p-2 rounded-2xl shadow-sm border border-[#A39B8B]/20 transform -rotate-1 hover:rotate-0 transition-transform duration-500 translate-x-4 md:translate-x-8" data-id="element-47">
            <div className="aspect-[16/10] bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 overflow-hidden relative" data-id="element-48">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100/50" data-id="element-49" />
              <div className="text-center relative z-10 p-6" data-id="element-50">
                <p className="text-sm font-medium text-gray-400 uppercase tracking-wider" data-id="element-51">
                  Client Notes
                </p>
              </div>
              {/* Abstract UI lines */}
              <div className="absolute bottom-4 left-4 right-4 space-y-2 opacity-30" data-id="element-52">
                <div className="h-2 bg-gray-200 rounded w-full" data-id="element-53"></div>
                <div className="h-2 bg-gray-200 rounded w-5/6" data-id="element-54"></div>
                <div className="h-2 bg-gray-200 rounded w-4/6" data-id="element-55"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}